import {
  FETCH_PAYMENT_DELIVERY_RANGES_PENDING,
  FETCH_PAYMENT_DELIVERY_RANGES_REJECTED,
  FETCH_PAYMENT_DELIVERY_RANGES_FULFILLED,
  CLEAR_PAYMENT_DELIVERY_RANGES,
} from '../constants/paymentDeliveryRanges';

const initialState = {
  pending: true,
  deliveryRanges: [],
  error: {},
};

export const paymentDeliveryRanges = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENT_DELIVERY_RANGES_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PAYMENT_DELIVERY_RANGES_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error,
      };

    case FETCH_PAYMENT_DELIVERY_RANGES_FULFILLED:
      return {
        ...state,
        deliveryRanges: action.data.results,
        pending: false,
        error: {},
      };

    case CLEAR_PAYMENT_DELIVERY_RANGES:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/paymentDeliveryRanges.js